import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from '../index.module.scss'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import CircleIcon from '@mui/icons-material/Circle'
import { useState } from 'react'
import { Menu, MenuItem } from '@mui/material'

interface IHeaderButton {
    text: string
    link: string
    isSelected?: boolean
}

const HeaderButton = ({ text, link }: IHeaderButton) => {
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <Button
            variant="text"
            onClick={() => navigate(link)}
            className={`${styles.headerButton_text} ${styles.headerButton} ${
                location.pathname.includes(link)
                    ? styles['headerButton--selected']
                    : 'neutral_black'
            }`}
            sx={{ fontFamily: 'Lexend Deca  !important' }}
        >
            {text}
        </Button>
    )
}

export default HeaderButton

interface IDropdownHeaderButton {
    text: string
    link?: string
    isSelected?: boolean
    customizedIcon?: JSX.Element
    options?: { text: string; link: string }[]
    handleClose?: () => void
    id?: string
}

export const DropdownHeaderButton = ({
    text,
    link,
    isSelected,
    customizedIcon,
    options,
    handleClose,
    id,
}: IDropdownHeaderButton) => {
    const navigate = useNavigate()

    const [open, setOpen] = useState(false)

    const handleNavigate = () => {
        handleClose?.()
        if (link) {
            navigate(link)
        }
    }

    return (
        <MenuItem
            id={id}
            onClick={
                options !== undefined ? () => setOpen(!open) : handleNavigate
            }
        >
            <Stack>
                <Button
                    variant="text"
                    onClick={() => setOpen(!open)}
                    className={
                        isSelected
                            ? styles['DropdownHeaderButton--selected']
                            : styles.DropdownHeaderButton
                    }
                >
                    <Stack
                        direction={'row'}
                        alignItems="center"
                        className={styles.DropdownHeaderButton__stack}
                    >
                        {isSelected ? (
                            <CircleIcon />
                        ) : !!options ? (
                            open ? (
                                <ArrowDropDownIcon />
                            ) : (
                                <ArrowRightIcon />
                            )
                        ) : (
                            customizedIcon || (
                                <ArrowRightIcon sx={{ color: 'transparent' }} />
                            )
                        )}
                        <div
                            className={`title_large ${
                                isSelected
                                    ? 'semi_bold_weight'
                                    : 'regular_weight'
                            }`}
                        >
                            {text}
                        </div>
                    </Stack>
                </Button>
                {options && (
                    <Stack
                        className={`${styles.dropdownContainer} ${open ? styles['dropdownContainer--open'] : ''}`}
                    >
                        {options.map((el, i) => (
                            <Button
                                key={`headerbutton_${i}`}
                                onClick={() => {
                                    navigate(el.link)
                                    handleClose && handleClose()
                                }}
                            >
                                {el.text}
                            </Button>
                        ))}
                    </Stack>
                )}
            </Stack>
        </MenuItem>
    )
}

interface IMenuHeaderButton {
    text: string
    link?: string
    config: { name: string; text: string; link: string }[]
    isSelected?: boolean
}
export const MenuHeaderButton = ({
    text,
    link,
    config,
    isSelected,
}: IMenuHeaderButton) => {
    const navigate = useNavigate()
    const [anchorEl, setAnchorEl] = useState<null | Element>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <Button
                variant="text"
                onClick={handleClick}
                className={`${styles.headerButton_text} ${styles.headerButton} ${
                    link && window.location.pathname.includes(link)
                        ? styles['headerButton--selected']
                        : 'neutral_black'
                }`}
                sx={{ fontFamily: 'Lexend Deca  !important' }}
            >
                {text}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    className: styles.menuListcontainer,
                    'aria-labelledby': 'basic-button',
                    onMouseLeave: handleClose,
                }}
                slotProps={{
                    paper: {
                        className: styles.dotButtonMenu,
                    },
                }}
                disableScrollLock
            >
                {config.map((el, i) => (
                    <MenuItem
                        key={`meanheaderbutton_${i}`}
                        className={styles.hoverMenuItem}
                        onClick={() => {
                            handleClose()
                            navigate(el.link)
                        }}
                    >
                        {el.text}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}
